import { render, staticRenderFns } from "./VehicleFees.vue?vue&type=template&id=22012fb2&scoped=true"
import script from "./VehicleFees.vue?vue&type=script&lang=js"
export * from "./VehicleFees.vue?vue&type=script&lang=js"
import style0 from "./VehicleFees.vue?vue&type=style&index=0&id=22012fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22012fb2",
  null
  
)

export default component.exports